import { tv } from '~/utils/tv'

export const SwitchToggleVariants = tv({
  base: `
    flex w-mediumlarge min-w-mediumlarge h-small rounded-mediumcontainer p-halfpulse focus-visible:outline outline-2 outline-offset-2
  `,
  variants: {
    isDisabled: {
      true: '',
    },
    isLoading: {
      true: '',
    },
  },
  compoundVariants: [
    {
      isDisabled: true,
      className: `
        bg-text-neutral-disabled cursor-not-allowed
      `,
    },
    {
      // @TODO: Change all tokens from backgroundColor when token is available
      isDisabled: false,
      isLoading: false,
      className: `
        data-[state=unchecked]:bg-[#9E9E9E]
        data-[state=checked]:bg-action-text-onbrand
        data-[state=unchecked]:active:bg-[#6B6B6B]
        data-[state=checked]:active:bg-action-text-onbrand-pressed
        data-[state=unchecked]:hover:bg-[#828282]
        data-[state=checked]:hover:bg-action-text-onbrand-hovered

      `,
    },
    {
      isDisabled: false,
      isLoading: true,
      className: `
        data-[state=unchecked]:bg-[#6B6B6B]
        data-[state=checked]:bg-action-text-onbrand-pressed
      `,
    },
  ],
})
